// extracted by mini-css-extract-plugin
export default {"entityNav":"EntityNavigation_entityNav__NTTEG","entityNavButton":"EntityNavigation_entityNavButton__+gXBp","entityNavPosition":"EntityNavigation_entityNavPosition__oKVM+"};